import { Stack, Typography } from '@lyearn/ui';

import { PlaceSuggestion } from '../types';

export const renderAutoCompleteOption = (val: PlaceSuggestion) => {
  const { id, name, description } = val;

  return (
    <Stack
      key={id}
      alignItems="start"
      className="w-full truncate px-12 py-10"
      direction="col"
      justifyContent="start">
      <Typography className="truncate" color="text-text-primary" variant="body-short-01">
        {name}
      </Typography>
      {description ? (
        <Typography className="mt-2 truncate" color="text-text-secondary" variant="body-short-03">
          {description}
        </Typography>
      ) : null}
    </Stack>
  );
};
